import { createContext, useContext } from "react";

/**
 * A section tab strip for the top bar's left slot. DashBoard provides one
 * (the Clinical tabs) on the pages it belongs to; UserHeader draws it on the
 * same row as the location switcher / feedback / avatar, in place of the page
 * title. null everywhere else, so every other top bar is unchanged.
 */
const HeaderTabsContext = createContext(null);

export const HeaderTabsProvider = HeaderTabsContext.Provider;

export const useHeaderTabs = () => useContext(HeaderTabsContext);
